// System
import React, { useMemo } from 'react';

// Components
import { TableBodyEx, TableContainerEx, TableEx } from '@Components/shared/tables/components';
import {
  ColumnVisibilityPresenter,
  TableHeadColumnsPresenter,
  TableHeadPresenter,
  TableRowPresenter,
} from '@Components/shared/tables/presenters';
import { LoadingScreen } from '@Components/shared/loaders/LoadingScreen';

// Utils
import { applyColumnVisibility } from '@utils/data/applyColumnVisibility';

//  Table
import { useFailedSendCreditTasksTableColumns } from './useFailedSendCreditTasksTableColumns';

// Redux
import { FailedSendCreditTasksDto } from '@contracts/api/dto/failedSendCreditTasksDto/FailedSendCreditTasksDto';
import { useFailedSendCreditTasksQuery } from '@Src/generated.graphql';
import { useFailedSendCreditTasksTable } from '@Modal/hooks/failedSendCreditTasks/useFailedSendCreditTasksTable';
import { useAuthorization } from '@Modal/hooks/authorization/useAuthorization';

export const FailedSendCreditTasksTable: React.FC = () => {
  const { columnVisibility, visiblityCustomizable, failedSendCreditTasksListFilters } =
    useFailedSendCreditTasksTable();
  const { userPermissions } = useAuthorization();
  const columns = useFailedSendCreditTasksTableColumns();

  const permissionToViewFailedSendCreditTasks = userPermissions?.includes(
    'CAN_VIEW_BACKOFFICE_TASKS'
  );

  const { data, loading } = useFailedSendCreditTasksQuery({
    skip: !permissionToViewFailedSendCreditTasks,
  });
  const visibleColumns = useMemo(
    () => applyColumnVisibility(columns, failedSendCreditTasksListFilters),
    [columns, columnVisibility]
  );

  const header = useMemo(
    () => (
      <TableHeadPresenter>
        <TableHeadColumnsPresenter columns={visibleColumns} />
        {/* @ts-ignore */}
        <ColumnVisibilityPresenter columns={columns} content={visiblityCustomizable} />
      </TableHeadPresenter>
    ),
    [columns]
  );

  if (!permissionToViewFailedSendCreditTasks) return <h1>No Permission</h1>;
  if (loading) return <LoadingScreen />;

  return (
    <>
      <TableContainerEx sx={{ height: '70vh' }}>
        <TableEx name="aviatorFailedSendCreditTasks">
          {header}
          <TableBodyEx>
            {/* @ts-ignore */}
            {data?.aviatorFailedSendCreditTasks?.map(
              // @ts-ignore
              (row: FailedSendCreditTasksDto) => (
                <TableRowPresenter
                  id={row.id}
                  key={row.id}
                  columns={visibleColumns}
                  row={row}
                  onClick={() => {}}
                />
              )
            )}
          </TableBodyEx>
        </TableEx>
      </TableContainerEx>
    </>
  );
};
